var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 6.85A2.85 2.85 0 0 1 4.85 4h14a2.85 2.85 0 0 1 2.85 2.85v10a2.85 2.85 0 0 1-2.85 2.85h-14A2.85 2.85 0 0 1 2 16.85v-10m1.7 2.588v7.412c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20 16.85V9.438l-6.569 4.38a2.85 2.85 0 0 1-3.162 0zM20 7.395l-7.512 5.008a1.15 1.15 0 0 1-1.276 0L3.7 7.395V6.85c0-.635.515-1.15 1.15-1.15h14c.635 0 1.15.515 1.15 1.15z",
  clipRule: "evenodd"
})));
export default SvgMail;